'use client';

import { Container } from '@chakra-ui/react';
import { startTransition, useEffect, useState } from 'react';

import { useI18n } from '@/__generated__/i18n.next';
import { Alert } from '@/components/__generated__/chakra-ui/alert';
import { isBrowserCompatible } from '@/utils/browserCompatibility';

import { DefaultFooterOnClient } from './DefaultFooterOnClient';

export const BrowserCompatibilityChecker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const t = useI18n();
  const [isSupported, setIsSupported] = useState(true);

  useEffect(() => {
    startTransition(() => {
      setIsSupported(isBrowserCompatible());
    });
  }, []);

  if (isSupported) {
    return <>{children}</>;
  }

  return (
    <>
      <Container py={16}>
        <Alert rounded="md" status="error" title={t.pages.error.unsupportedBrowser()}>
          {t.pages.error.unsupportedBrowserMessage()}
        </Alert>
      </Container>

      <DefaultFooterOnClient />
    </>
  );
};
